'use client';

import { LoadingButton } from '@/components/ui/loading-button';
import { useToast } from '@/components/ui/use-toast';
import { useAppSelector } from '@/lib/RTK/hooks';
import { axiosClientInstance } from '@/lib/servies/axiosConfig';
import { formatPrice } from '@/hook/formatPrice';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import { TypePaymanCom } from './types/Typeschild_id';
import Link from 'next/link';

export default function PaymentCom(props: TypePaymanCom) {
    const searchParams = useSearchParams();
    const formId = searchParams.get('formId');

    const { pricepaid } = props;
    const {
        doctor_visits,
        site_price,
        visit_price,
        disabledBtn,
        requiredInformationFields,
        setdisabledBtn,
        disabledBtnFile,
        doctor_id,
        clinic_id,
        formValuesInformation,
        // setFiles,
        files,
        plus_checked,
        coordination_fields,
        time_specialist,
        get_amount_special,
    } = pricepaid;
    const { wallet, tax } = pricepaid;

    const { currentTurnTimeDate } = useAppSelector((s) => s.admission);
    const { tracking_code, token } = useAppSelector((s) => s.auth_token_slice);
    const plus_id = useAppSelector((s) => s.DocTurnStatus.plus_id);
    const { toast } = useToast();

    const walletAmount = Number(wallet) + 0;
    const router = useRouter();

    const [finalPrice, setFinalPrice] = useState<null | number>(
        (visit_price === 0 || !visit_price) && doctor_visits.length <= 0
            ? site_price
            : visit_price !== 0
            ? visit_price + site_price
            : null,
    );
    const [selectedVisit, setSelectedVisit] = useState<
        number | number[] | null
    >(null);

    const [isWallet, setIsWallet] = useState<boolean>(false);
    const [adjustedPrice, setAdjustedPrice] = useState<number | null>(
        finalPrice,
    );
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDone, setIsDone] = useState<boolean>(false);

    function handleCheckToast() {
        if (disabledBtnFile) {
            toast({
                title: 'لطفا تمام مدارک را کامل نمایید !',
                variant: 'error',
            });
        }
    }

    //! USE_EFFECT_START

    useEffect(() => {
        setdisabledBtn(finalPrice === null);
    }, [finalPrice]);

    useEffect(() => {
        const selectedVisitPrice = doctor_visits.find(
            (v) => v.id === selectedVisit,
        )?.amount;

        setFinalPrice(
            (!visit_price || visit_price === 0) && doctor_visits.length <= 0
                ? site_price
                : visit_price !== 0
                ? selectedVisitPrice
                    ? site_price
                    : visit_price + site_price
                : null,
        );
    }, [pricepaid]);

    useEffect(() => {
        if (selectedVisit === null) {
            setFinalPrice(
                (visit_price === 0 || !visit_price) && doctor_visits.length <= 0
                    ? site_price
                    : visit_price !== 0
                    ? site_price
                    : null,
            );
            return;
        }

        if (typeof selectedVisit === 'number') {
            const selectedVisitPrice = doctor_visits.find(
                (v) => v.id === selectedVisit,
            )?.amount;
            if (selectedVisitPrice) {
                setFinalPrice(site_price + Number(selectedVisitPrice));
            }
        } else if (Array.isArray(selectedVisit)) {
            let visitPrice = 0;
            selectedVisit.forEach((v) => {
                const price = doctor_visits.find((v1) => v1.id === v)?.amount;
                if (price) {
                    visitPrice += Number(price);
                }
            });
            setFinalPrice(site_price + visitPrice);
        }
    }, [selectedVisit, pricepaid]);

    useEffect(() => {
        if (isWallet && finalPrice !== null) {
            const newAdjustedPrice = Math.max(finalPrice - walletAmount, 0);
            setAdjustedPrice(newAdjustedPrice);
        } else {
            setAdjustedPrice(finalPrice);
        }
    }, [isWallet, finalPrice]);

    const walletBalanceAfterPayment = useMemo(() => {
        return isWallet
            ? Math.max(walletAmount - (finalPrice ?? 0), 0)
            : walletAmount;
    }, [isWallet]);

    //* USE_EFFECT_END

    function handlePayMent() {
        const formData = new FormData();
        if (tracking_code) {
            formData.append('tr', tracking_code);
        }
        if (formId) {
            formData.append('doctor_reserve_form', formId);
        }
        formData.append('date', currentTurnTimeDate?.date || '');
        formData.append('time', currentTurnTimeDate?.time || '');
        formData.append('doctor_id', doctor_id ? doctor_id.toString() : '');
        formData.append(
            'clinic_id',
            plus_id !== null
                ? '0'
                : clinic_id === 'matab'
                ? '0'
                : clinic_id.toString(),
        );
        formData.append('plus_id', plus_id !== null ? plus_id.toString() : '0');
        formData.append(
            'child_id',
            currentTurnTimeDate?.childId
                ? currentTurnTimeDate.childId.toString()
                : '0',
        );
        formData.append(
            'share_id',
            selectedVisit ? selectedVisit.toString() : '',
        );
        formData.append('wallet', isWallet ? 'yes' : 'no');
        formData.append(
            'share_id',
            selectedVisit ? selectedVisit.toString() : '',
        );
        formData.append('father_name', formValuesInformation.father_name || '');
        formData.append('basic_ins', formValuesInformation.basic_ins || '');
        formData.append(
            'complete_ins',
            formValuesInformation.complete_ins || '',
        );
        formData.append('address', formValuesInformation.address || '');
        formData.append('file_count', files.length.toString());

        files.forEach((file, index) => {
            if (file && file.size > 0) {
                formData.append(`file${index + 1}`, file);
            }
        });

        if (coordination_fields && coordination_fields.length > 0) {
            coordination_fields.forEach((name, index) => {
                formData.append(`file_title${index + 1}`, name);
            });
        }

        setIsLoading(true);

        axiosClientInstance
            .post(`/submit_turn`, formData, {
                headers: {
                    Auth: `Bearer ${token}`,
                },
            })
            .then((response) => {
                if (response.data?.status === 1) {
                    if (response?.data?.result?.pay === 'no') {
                        const tracking_code =
                            response.data.result.tracking_code;
                        router.push(
                            `${process.env.NEXT_PUBLIC_STATIC_URL}/TurnPay?tr=${tracking_code}`,
                        );
                        setIsDone(true);
                    } else if (response?.data?.result?.pay === 'yes') {
                        router.push(
                            `/turn_result?status=1&tracking_code=${response?.data?.result?.tracking_code}&message=${response?.data.result?.message}&recipt=${response?.data.result?.recipt}`,
                        );
                        setIsDone(true);
                    }
                } else if (response.data?.status === 0) {
                    toast({
                        title: response.data?.result?.message,
                        variant: 'error',
                    });
                }
            })
            .catch(() => {
                toast({
                    title: 'ارتباط برقرار نشد لطفا دوباره تلاش نمایید !',
                    variant: 'error',
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const isInformationComplete = requiredInformationFields.every((field) => {
        const fieldKey = field as keyof typeof formValuesInformation;
        const fieldValue = formValuesInformation[fieldKey];
        return fieldValue && fieldValue.trim() !== '';
    });

    return (
        <div
            className="p-4 bg-white rounded-2xl flex flex-col gap-4"
            id="section-payment"
        >
            {time_specialist == 1 && get_amount_special == 'no' ? (
                <>
                    <p className="text-black font-bold md:!text-base text-sm inline p-[2px] rounded-sm">
                        جزئیات درخواست
                    </p>
                    <p>
                        پس از ثبت درخواست نوبت کارشناسان جهت هماهنگی با شما تماس
                        خواهند گرفت.
                    </p>
                </>
            ) : (
                <>
                    <p className="text-black font-bold md:!text-base text-sm inline p-[2px] rounded-sm">
                        جزئیات پرداخت
                    </p>
                    <div className="space-y-3">
                        <div className="flex justify-between items-center">
                            <p className="font-medium text-gray-500 md:text-sm text-xs">
                                هزینه کارمزد و زیرساخت
                            </p>
                            <p className="font-semibold">
                                {formatPrice(site_price)}
                            </p>
                        </div>

                        <div className="flex justify-between items-center">
                            <p className="font-medium text-gray-500 md:text-sm text-xs">
                                {' '}
                                مالیات بر ارزش افزوده :
                            </p>
                            <p className="font-semibold">{formatPrice(tax)}</p>
                        </div>

                        {}
                        <div className="flex justify-between items-center">
                            <p className="font-medium text-gray-500 md:text-sm text-xs">
                                {' '}
                                مبلغ قابل پرداخت:
                            </p>
                            <p className="font-semibold">
                                {' '}
                                {finalPrice !== null
                                    ? formatPrice(finalPrice + tax)
                                    : '---'}
                            </p>
                        </div>
                    </div>
                    {doctor_visits && doctor_visits.length && plus_checked === 0
                        ? doctor_visits.map((i) => (
                              <>
                                  <p className="font-bold text-base">
                                      روش پرداخت:{' '}
                                      {adjustedPrice === null && (
                                          <p className="text-sm text-red-600">
                                              لطفا ابتدا نوع نوبت درخواستی را
                                              انتخاب کنید !
                                          </p>
                                      )}
                                  </p>
                                  <div
                                      key={i.id}
                                      className="flex flex-row justify-start items-center gap-2"
                                  >
                                      <input
                                          type="radio"
                                          name="doctor_visit"
                                          className="checked_input_style accent-blue !size-[20px] !outline-0 rounded-full"
                                          value={i.id}
                                          id={`radio-${i.id}`}
                                          onChange={(e) =>
                                              setSelectedVisit(
                                                  Number(e.target.value),
                                              )
                                          }
                                      />
                                      <label
                                          htmlFor={`radio-${i.id}`}
                                          className="mx-1 text-xs md:text-sm"
                                      >
                                          {i.title}:{' '}
                                          {formatPrice(Number(i.amount))}
                                      </label>
                                  </div>
                              </>
                          ))
                        : doctor_visits.map((i) => (
                              <div
                                  key={i.id}
                                  className="flex flex-row justify-start items-center gap-2"
                              >
                                  <input
                                      type="checkbox"
                                      name="doctor_visit"
                                      className="checkbox_style"
                                      value={i.id}
                                      id={`checkbox-${i.id}`}
                                      onChange={(e) => {
                                          if (typeof selectedVisit === 'number')
                                              return;
                                          let values =
                                              selectedVisit !== null
                                                  ? [...selectedVisit]
                                                  : [];
                                          if (
                                              e.target.checked &&
                                              !values.includes(
                                                  Number(e.target.value),
                                              )
                                          ) {
                                              values.push(
                                                  Number(e.target.value),
                                              );
                                          } else if (
                                              values.includes(
                                                  Number(e.target.value),
                                              )
                                          ) {
                                              values = values.filter(
                                                  (v) =>
                                                      v !==
                                                      Number(e.target.value),
                                              );
                                          }
                                          setSelectedVisit(
                                              values.length > 0 ? values : null,
                                          );
                                      }}
                                  />
                                  <label
                                      htmlFor={`checkbox-${i.id}`}
                                      className="mx-1 text-xs md:text-sm"
                                  >
                                      {i.title}: {formatPrice(Number(i.amount))}
                                  </label>
                              </div>
                          ))}

                    <hr className="w-full border-dashed md:!block hidden" />
                </>
            )}

            <div className="md:!relative rounded-t-xl md:!rounded-none left-0 right-0 md:bg-transparent bg-white space-y-3 md:!p-0 p-4 border-gray-200 md:!border-0 border bottom-0 fixed shadow-lg shadow-black md:shadow-none">
                {time_specialist == 1 && get_amount_special == 'no' ? (
                    <div className="w-full" onClick={handleCheckToast}>
                        <LoadingButton
                            loading={isLoading}
                            className="bg-blue !text-white hover:bg-primary w-full"
                            onClick={isDone ? undefined : handlePayMent}
                        >
                            ثبت درخواست
                        </LoadingButton>
                        <div className="text-center pt-2 text-xs">
                            پرداخت به منزله پذیرش{' '}
                            <Link className=" text-blue-600" href={'/rules'}>
                                شرایط و قوانین
                            </Link>{' '}
                            است.
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="flex flex-row justify-start items-center gap-1">
                            <input
                                id="wallet"
                                type="checkbox"
                                disabled={
                                    finalPrice === null || walletAmount === 0
                                }
                                checked={isWallet}
                                onChange={(e) => setIsWallet(e.target.checked)}
                                className="checkbox_style accent-blue"
                            />
                            <label
                                htmlFor="wallet"
                                className="mx-1 text-xs md:text-sm flex flex-wrap"
                            >
                                پرداخت از کیف پول : موجودی{' '}
                                {isWallet && finalPrice !== null ? (
                                    <div className="space-x-2">
                                        <p className="line-through pr-1 text-red-500">
                                            {formatPrice(walletAmount)}
                                        </p>
                                        <span>-</span>
                                        <span>
                                            {' موجودی پس از پرداخت : '}
                                            {formatPrice(
                                                walletBalanceAfterPayment,
                                            )}
                                        </span>
                                    </div>
                                ) : (
                                    formatPrice(walletAmount)
                                )}
                            </label>
                        </div>

                        <hr className="w-1/2 border-none" />

                        <div className="md:!mt-3 !mt-0 flex-col flex gap-2 justify-center items-end">
                            {disabledBtnFile && (
                                <p className="text-[#D30606] text-right w-full text-sm">
                                    لطفا فایل های مورد نیاز را کامل نمایید !
                                </p>
                            )}
                            <div className="w-full" onClick={handleCheckToast}>
                                <LoadingButton
                                    loading={isLoading}
                                    className="bg-blue !text-white hover:bg-primary w-full"
                                    disabled={
                                        isLoading ||
                                        !isInformationComplete ||
                                        disabledBtn ||
                                        disabledBtnFile ||
                                        (doctor_visits &&
                                            doctor_visits.length > 0 &&
                                            plus_checked === 0 &&
                                            !selectedVisit) ||
                                        (doctor_visits &&
                                            doctor_visits.length > 0 &&
                                            doctor_visits.some(
                                                (i) => !i.amount,
                                            )) ||
                                        isDone
                                    }
                                    onClick={isDone ? undefined : handlePayMent}
                                >
                                    {adjustedPrice === null ||
                                    adjustedPrice === 0
                                        ? 'ثبت نهایی'
                                        : 'پرداخت ' +
                                          formatPrice(adjustedPrice + tax)}
                                </LoadingButton>
                                <div className="text-center pt-2 text-xs">
                                    پرداخت به منزله پذیرش{' '}
                                    <Link
                                        className=" text-blue-600"
                                        href={'/rules'}
                                    >
                                        شرایط و قوانین
                                    </Link>{' '}
                                    است.
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
